const setOpacity = (element, value) => {
    element.style.opacity = value / 10;
    element.style.filter = `alpha(opacity=${value * 10})`;
};
export default setOpacity;
